import { AfterViewInit, Directive, ElementRef, HostBinding, Input, Renderer2 } from '@angular/core';
import { DocumentDownloadService } from '../../adapters/documentDownload.service';
import { environment } from '../../../environments/environment';


@Directive({
    selector: 'img[lazyload]',
    inputs: [
        "data: lazyload", //โหลดภาพจาก Data Engine lazyload="{"dataset_name": ?,"request_data":{"doc_id":?}}"
        "imageDefault: src-default", //ระบุเมื่อต้องการกำหนดภาพ Default 
        'autoload: autoload'
    ],
    host: {
        '(error)': 'onError()'
    },
    standalone: false
})
export class LazyLoadDirective implements AfterViewInit {
  @HostBinding('attr.src') srcAttr: any;
  @Input() src: string;
  data: any;
  imageDefault: string;
  autoload: string;
  baseUrl: string = environment.images_url;
  constructor(private el: ElementRef, private renderer: Renderer2, private documentDownloadService: DocumentDownloadService) { }

  ngAfterViewInit() {
    if (this.isIE() || this.autoload === "true") {
      this.loadImage();
    } else {
      this.canLazyLoad() ? this.lazyLoadImage() : this.loadImage();
    }
  }

  private canLazyLoad() {
    return window && 'IntersectionObserver' in window;
  }

  private lazyLoadImage() {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(({ isIntersecting }) => {
        if (isIntersecting) {
          this.loadImage();
          obs.unobserve(this.el.nativeElement);
        }
      });
    });
    obs.observe(this.el.nativeElement);
  }

  private loadImage() {
    if (this.data != null && typeof this.data === 'object' && this.data.dataset_name && this.data.request_data && this.data.request_data.doc_id) {
      if (this.baseUrl == '') {
        let body = { "dataset_name": this.data.dataset_name, "request_data": { "doc_id": this.data.request_data.doc_id } };
        this.documentDownloadService.exec(body).then(
          res => {
            this.createImageFromBlob(res)
            this.renderer.removeClass(this.el.nativeElement.parentNode, 'skeleton-box');
            this.renderer.setStyle(this.el.nativeElement, 'visibility', "visible")
          },
          () => { this.onError(); }
        );
      } else {
        // let that = this;
        // setTimeout(() => {
        //   that.srcAttr = this.baseUrl + this.data.request_data.doc_id;
        // }, 100);
        this.renderer.setAttribute(this.el.nativeElement,'src',this.baseUrl+this.data.request_data.doc_id);
      }
    
      this.renderer.removeClass(this.el.nativeElement.parentNode, 'skeleton-box');
      this.renderer.setStyle(this.el.nativeElement, 'visibility', "visible")

    }else if(typeof this.data === 'string' && this.data != '' && this.data != null){
      this.renderer.removeClass(this.el.nativeElement.parentNode, 'skeleton-box');
      this.renderer.setStyle(this.el.nativeElement, 'visibility', "visible")
      this.renderer.setAttribute(this.el.nativeElement,'src',this.baseUrl+this.data);
    } else {
      this.renderer.setAttribute(this.el.nativeElement, 'src', this.src)
      this.renderer.removeClass(this.el.nativeElement.parentNode, 'skeleton-box')
      //this.renderer.setStyle(this.el.nativeElement, 'visibility', "visible")
    }

  }

  private createImageFromBlob(image) {
    // let reader = new FileReader();
    // reader.addEventListener("load", () => {
    //   this.srcAttr = this.sanitizer.bypassSecurityTrustUrl((reader.result).toString());
    // }, false);
    // if (image) {
    //   reader.readAsDataURL(image)
    // }
    this.renderer.setAttribute(
      this.el.nativeElement,
      'src',
      window.URL.createObjectURL(image)
    );
  }

  public onError() {
    this.renderer.removeClass(this.el.nativeElement.parentNode, 'skeleton-box');
    if (this.imageDefault) {
      this.renderer.setAttribute(this.el.nativeElement, 'src', this.imageDefault);
    } else {
      this.renderer.setStyle(this.el.nativeElement, 'visibility', "hidden")
    }
  }

  private isIE() {
    var ua = navigator.userAgent;
    var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
    return is_ie;
  }

}
